import { render, staticRenderFns } from "./MyTableNew.vue?vue&type=template&id=eb89bdf8&scoped=true"
import script from "./MyTableNew.vue?vue&type=script&lang=js"
export * from "./MyTableNew.vue?vue&type=script&lang=js"
import style0 from "./MyTableNew.vue?vue&type=style&index=0&id=eb89bdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb89bdf8",
  null
  
)

export default component.exports